/* eslint-disable import/prefer-default-export */
import _map from 'lodash/map';
import store from '../store';
import router from '../router';

export function copy(object) {
    return JSON.parse(JSON.stringify(object));
}

export function open_in_topic(space, topic, path, note) {
    store.commit('tree/open_collection', {
        collection_ids: _map(path || [], 'id'),
    });

    router.push({
        name: 'content',
        query: { topic, note },
        params: { space },
    });
}


export function set_title(title) {
    document.title = `TEAMFORCE | ${title}`;
}
